export default "__VITE_ASSET__p1nw$Ms9__"